import urlData from '@shared/utilities/routes';
import { useMemo } from 'react';

import MigrationLink from '../MigrationLink/MigrationLink';
import AuctionsLogo from './logos/AuctionsLogo';
import AuctionsLogoIconOnly from './logos/AuctionsLogoIconOnly';
import CarMaxLogoInternal from './logos/CarMaxLogoInternal';

interface Props {
    className?: string;
    lightTheme?: boolean;
    logoType?: 'large' | 'small' | 'small-icon-only' | 'mini-icon-only' | 'internal';
    onClick?: (Event) => void;
}

export default function CarMaxLogo({
    className = '',
    lightTheme = false,
    logoType = 'large',
    onClick = null,
}: Props) {
    const renderLogo = useMemo(() => {
        switch (logoType) {
            case 'large':
                return (
                    <AuctionsLogo
                        lightTheme={lightTheme}
                        width="200"
                        height="48"
                        viewBox="0 0 644 160"
                    />
                );
            case 'small':
                return (
                    <AuctionsLogo
                        lightTheme={lightTheme}
                        width="122"
                        height="30"
                        viewBox="0 0 644 160"
                    />
                );
            case 'small-icon-only':
                return (
                    <AuctionsLogoIconOnly
                        lightTheme={lightTheme}
                        width="32"
                        height="32"
                        viewBox="0 0 159 160"
                    />
                );
            case 'mini-icon-only':
                return (
                    <AuctionsLogoIconOnly
                        lightTheme={lightTheme}
                        width="24"
                        height="24"
                        viewBox="0 0 160 160"
                    />
                );
            case 'internal':
                return <CarMaxLogoInternal width="32" height="32" />;
        }
    }, [lightTheme, logoType]);

    return (
        <MigrationLink config={urlData.home} className={className} onClick={onClick}>
            {renderLogo}
        </MigrationLink>
    );
}
